import React from 'react';
import { Plus } from 'lucide-react';
import { FaqItem } from '../types';

/**
 * Natives <details>/<summary> statt eines JS-Akkordeons: Alle Antworten stehen
 * im ausgelieferten HTML (Suchmaschinen, ohne JavaScript) und sind per Tastatur bedienbar.
 */
const FaqAccordion: React.FC<{ items: FaqItem[]; firstOpen?: boolean }> = ({ items, firstOpen = true }) => (
  <div className="divide-y divide-line overflow-hidden rounded-2xl border border-line bg-surface/60">
    {items.map((item, i) => (
      <details key={item.question} className="group" open={firstOpen && i === 0}>
        <summary className="flex cursor-pointer list-none items-start justify-between gap-6 px-6 py-5 transition-colors hover:bg-white/[.02] [&::-webkit-details-marker]:hidden">
          <span className="text-[1.05rem] font-medium leading-snug text-white">{item.question}</span>
          <span className="mt-0.5 inline-flex size-7 shrink-0 items-center justify-center rounded-full border border-line-2 text-primary transition-transform duration-300 group-open:rotate-45 group-open:border-primary/50" aria-hidden="true">
            <Plus className="size-4" />
          </span>
        </summary>
        <div className="px-6 pb-6 pr-16 leading-relaxed text-muted">
          <p>{item.answer}</p>
        </div>
      </details>
    ))}
  </div>
);

export default FaqAccordion;
